import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {AppStateService} from "../providers/app-state.service";
import {tap} from "rxjs/operators";
import {Article} from "../models/article.model";
import {ArticleService} from "../providers/article.service";

@Injectable()
export class SupportResolve implements Resolve<Article> {
  constructor(private articleService: ArticleService, private appStateService: AppStateService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<Article> {
    this.appStateService.updateIsBusySubject(true);
    let paramMap = route.paramMap;
    console.log(paramMap);
    if (paramMap.has('alias')) {
      let alias = paramMap.get('alias');
      console.log(alias);
      return this.articleService.getFAQArticleByAlias(alias).pipe(tap(res => {
        console.log(res);
        this.appStateService.updateIsBusySubject(false);
      }));
    }

  }
}
